import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Frac } from '~lmo/models/frac.model';
import { FracClusterPurchaseOrder } from '~lmo/models/purchaseOrders.model';
import { LmoFracsService } from '~lmo/services';
import { LmoFracFcpoService } from '~lmo/services/lmo-frac-fcpo.service';
import { LmoFracMineService } from '~lmo/services/lmo-frac-mine.service';
import { LmoFracModalService } from '~lmo/services/lmo-frac-modal.service';
import { ErrorHandlingService } from '~services/error-handling.service';
import { trackById } from '~utilities/trackById';

@Component({
  selector: 'sa-lmo-frac-fcpo-loader-directions',
  styleUrls: ['./lmo-frac-fcpo-loader-directions.component.scss'],
  templateUrl: './lmo-frac-fcpo-loader-directions.component.html',
})
export class LmoFracFcpoLoaderDirectionsComponent implements OnInit {
  public trackById = trackById;

  public loaderDirectionForm: FormGroup;
  public formSubmitted$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public submitting$$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public well;
  public currentFracFcpos$: BehaviorSubject<FracClusterPurchaseOrder[]> = new BehaviorSubject<
    FracClusterPurchaseOrder[]
  >([]);
  public frac$: Observable<Frac>;

  constructor(
    private fracService: LmoFracsService,
    private fb: FormBuilder,
    private fcpoService: LmoFracFcpoService,
    private fracMineService: LmoFracMineService,
    private errorService: ErrorHandlingService,
    private modalService: LmoFracModalService,
  ) {}

  public ngOnInit() {
    this.frac$ = this.fracService.currentFrac$;

    this.fcpoService.currentFracFcpos$.subscribe((fcpos) => {
      this.currentFracFcpos$.next(fcpos);
    });

    this.frac$.pipe(filter((frac) => !!frac)).subscribe((well) => {
      this.well = well;
      this.createLoaderDirectionForm();
    });
  }

  public submit() {
    if (this.submitting$$.value) {
      return;
    }

    this.formSubmitted$.next(false);

    const fracMines = [];
    if (this.loaderDirectionForm.controls['mines'].value) {
      this.loaderDirectionForm.controls['mines'].value.forEach((mine) => {
        mine.direction = this.loaderDirectionForm.controls['mine_' + mine.id + '_direction'].value;
        fracMines.push(mine);
      });
    }

    if (this.loaderDirectionForm.valid) {
      this.submitting$$.next(true);
      // insert code to update mine/loader directions here
      this.fracMineService.updateFracMineDirections$(fracMines).subscribe(
        (successful) => {
          if (successful) {
            this.modalService.closeHomeModal();
          }
          this.submitting$$.next(false);
        },
        (err) => {
          this.submitting$$.next(false);
          this.errorService.showError(err, 5000);
        },
      );
    }
  }

  private createLoaderDirectionForm() {
    this.loaderDirectionForm = this.fb.group({
      mines: [(this.well ? this.well.fracMines : []) as any[], []],
    });
    if (this.loaderDirectionForm.controls['mines'].value) {
      this.loaderDirectionForm.controls['mines'].value.forEach((mine) => {
        this.loaderDirectionForm.addControl(
          'mine_' + mine.id + '_direction',
          this.fb.control(mine.direction ? mine.direction : '', []),
        );
        this.loaderDirectionForm.addControl(
          'mine_' + mine.id + '_mileage',
          this.fb.control(mine.loadMileage ? mine.loadMileage : null, [Validators.min(0)]),
        );
      });
    }
    this.formLoading$.next(false);

    this.onMineChange();
  }

  private onMineChange() {
    this.loaderDirectionForm.get('mines').valueChanges.subscribe(() => {
      if (this.loaderDirectionForm.controls['mines'].value) {
        this.loaderDirectionForm.controls['mines'].value.forEach((mine) => {
          this.loaderDirectionForm.addControl(
            'mine_' + mine.id + '_direction',
            this.fb.control(mine.direction ? mine.direction : '', []),
          );
          this.loaderDirectionForm.addControl(
            'mine_' + mine.id + '_mileage',
            this.fb.control(mine.loadMileage ? mine.loadMileage : null, [Validators.min(0)]),
          );
        });
      }
    });
  }
}
